var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusicNoteDouble(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.668 12.0703C13.4043 12.0703 14.0013 11.486 14.0013 10.7653C14.0013 10.0446 13.4043 9.46034 12.668 9.46034C11.9316 9.46034 11.3346 10.0446 11.3346 10.7653C11.3346 11.486 11.9316 12.0703 12.668 12.0703ZM12.668 13.3752C14.1407 13.3752 15.3346 12.2067 15.3346 10.7653C15.3346 9.32388 14.1407 8.15538 12.668 8.15538C11.1952 8.15538 10.0013 9.32388 10.0013 10.7653C10.0013 12.2067 11.1952 13.3752 12.668 13.3752Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33464 14.0277C4.07102 14.0277 4.66797 13.4435 4.66797 12.7228C4.66797 12.002 4.07102 11.4178 3.33464 11.4178C2.59826 11.4178 2.0013 12.002 2.0013 12.7228C2.0013 13.4435 2.59826 14.0277 3.33464 14.0277ZM3.33464 15.3327C4.80739 15.3327 6.0013 14.1642 6.0013 12.7228C6.0013 11.2813 4.80739 10.1128 3.33464 10.1128C1.86188 10.1128 0.667969 11.2813 0.667969 12.7228C0.667969 14.1642 1.86188 15.3327 3.33464 15.3327Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0607 0.79124C15.2328 0.91406 15.3346 1.11 15.3346 1.3185V10.7653H14.0013V2.21359L6.0013 4.06364L6.0013 12.7228H4.66797L4.66797 3.58801C4.66797 3.30457 4.85493 3.05356 5.13063 2.96682L14.464 0.697321C14.6668 0.633518 14.8885 0.668421 15.0607 0.79124Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.872 4.54962L5.53864 6.81912L5.13063 5.57676L14.464 3.30725L14.872 4.54962Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicNoteDouble);
export default __webpack_public_path__ + "static/media/musicNoteDouble.cd7afb8c.svg";
export { ForwardRef as ReactComponent };